import { render } from "./CampaignItem.vue?vue&type=template&id=ec98c23c&scoped=true"
import script from "./CampaignItem.vue?vue&type=script&lang=js"
export * from "./CampaignItem.vue?vue&type=script&lang=js"

import "./CampaignItem.vue?vue&type=style&index=0&id=ec98c23c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec98c23c"]])

export default __exports__